import { render, staticRenderFns } from "./CollabOverlay.vue?vue&type=template&id=f87247f0&scoped=true&"
import script from "./CollabOverlay.vue?vue&type=script&lang=js&"
export * from "./CollabOverlay.vue?vue&type=script&lang=js&"
import style0 from "./CollabOverlay.vue?vue&type=style&index=0&id=f87247f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87247f0",
  null
  
)

export default component.exports